import { Box } from '@global-engineering-shared/gweb-material-ui';
import React, { CSSProperties, ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableFooter from 'components/Table/components/TableFooter/TableFooter';
import TableHeader from 'components/Table/components/TableHeader/TableHeader';
import Table from 'components/Table/Table';
import { defaultDates } from 'context/DateProvider/DateProvider';
import { usePaginatedItemsContext } from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { PaginatedItems } from 'context/PaginatedItems/types/PaginatedItems';
import TableCollapsedContent from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContent';
import useStyles from 'features/Frames/components/Frames/FramesTable/FramesTable.styles';
import { Frame } from 'features/Frames/types';
import { columns } from 'features/Status/utils/frames';
import { stateColour } from 'features/Status/utils/state';
import { FRAMES_PAGE_URL } from 'utils/defaults';

type FramesTableProps = {
  idSuffix: string;
  showHeaderIfEmpty?: boolean;
  header?: ReactElement;
  headerSupplier?: (totalItems: number) => ReactElement;
};

const FramesTable = ({ idSuffix, showHeaderIfEmpty, header, headerSupplier }: FramesTableProps) => {
  const tableItemGridTemplate = '10% 1fr 7.5% 14% 14%  15%';

  const classes = useStyles();

  const navigate = useNavigate();

  const { items, currentItems, totalElements, canLoadMore, loadMore } =
    usePaginatedItemsContext() as PaginatedItems<Frame>;

  useEffect(() => {}, [items]);

  const handleRowClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, frameId: string) => {
    const url = `${FRAMES_PAGE_URL}/${frameId}?from=${defaultDates.from}&to=${defaultDates.to}`;
    if (event.metaKey || event.ctrlKey) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  const getHeader = () => {
    if (header) {
      return header;
    }
    if (headerSupplier) {
      return headerSupplier(totalElements);
    }
    return <></>;
  };

  const itemStyle = (item: Frame): CSSProperties => ({
    borderLeftColor: stateColour(item.status?.state),
  });

  return (
    <>
      {totalElements === 0 && showHeaderIfEmpty && <Box>{getHeader()}</Box>}
      {totalElements > 0 && (
        <Box>
          {getHeader()}
          <TableHeader
            idSuffix={idSuffix}
            tableItemGridTemplate={tableItemGridTemplate}
            columns={columns}
          />
          <Table
            tableItemGridTemplate={tableItemGridTemplate}
            items={items}
            keyName="id"
            columns={columns}
            expandOnClick={true}
            classes={classes}
            itemStyle={itemStyle}
            handleRowClick={(event, frame) => handleRowClick(event, frame.id)}
            collapsedContent={(frame) => <TableCollapsedContent frame={frame} />}
          />
          <TableFooter
            currentItems={currentItems}
            totalItems={totalElements}
            canLoadMore={canLoadMore}
            handleLoadMore={loadMore}
            loading={false}
            label="frames"
          />
        </Box>
      )}
    </>
  );
};

export default FramesTable;
